import Controller from "../Engine/Controller";
import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

class Input extends Controller{

    constructor(dom, options) {
        super(dom, "Input");

        if (this.domNode.getAttribute("type")=="file") {
            this.value = null;

            this._appendFileTypeEvents();
        }
    }
    /*
    * append listeners and events to file type input
    */
    _appendFileTypeEvents() {
        let domNode = this.domNode,
            that = this;

        cfJS.addListener(domNode,"change", function () {
            if (this.files) {
                that.value = this.files[0];
                //console.log (this.files[0]);
            }
        });
    }
    /*
    * get setted value from input
    */
    getValue() {
        return this.value;
    }

}

window.Input = Input;